/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    init: function() {
      if ( !window.hasMotion ) {
        return;
      }

      const wheelGraphics = document.querySelectorAll( '.wheel-graphic' );

      if ( !wheelGraphics.length ) {
        return;
      }

      wheelGraphics.forEach( ( wheel ) => {
        gsap.to( wheel, {
          rotation: 360,
          ease: 'none',
          scrollTrigger: {
            trigger: wheel,
            start: 'top bottom',
            end: 'bottom+=200px',
            scrub: 1,
          },
        } );
      } );
    },


    finalize: function() {
    },
  };

  app.registerComponent( 'wheel', COMPONENT );
} )( app );
